"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _slicedToArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));

var _socket = _interopRequireDefault(require("@/assets/js/socket.js"));

var _vuex = require("vuex");

var _markets = require("@/model/markets/markets");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default
  },
  props: {
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      ws: null,
      tradePair: [],
      tradePairArray: [],
      selectSymbol: "",
      symbol: "",
      // tabList: [
      //   {
      //     value: "self",
      //     label: this.translateTitle("自选"),
      //   },
      //   {
      //     value: "usdt",
      //     label: "USDT",
      //   },
      //   {
      //     value: "btc",
      //     label: "BTC",
      //   },
      //   {
      //     value: "busd",
      //     label: "BUSD",
      //   },
      // ],
      currIndex: "usdt",
      selfOptionsList: []
    };
  },
  created: function created() {
    var tempSymbol = this.$route.params.symbol || "btc_usdt";
    this.symbol = tempSymbol;
    this.getOptionList(); // this.getTradePairList();

    var _tempSymbol$split = tempSymbol.split("_"),
        _tempSymbol$split2 = (0, _slicedToArray2.default)(_tempSymbol$split, 2),
        coinFrom = _tempSymbol$split2[0],
        coinTo = _tempSymbol$split2[1];

    if (coinTo.toLowerCase() == "btc") {
      this.currIndex = "btc";
    } else if (coinTo.toLowerCase() == "busd") {
      this.currIndex = "busd";
    } else {
      this.currIndex = "usdt";
    }
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;
      var trade_pair = this.symbol.toLowerCase();

      if (row.info.name.toLowerCase() == trade_pair) {
        return "warning-row";
      } else {
        return "";
      }
    },
    getRowKeys: function getRowKeys(row) {
      return row.symbol_id;
    },
    addOption: function addOption(row, type) {
      var _this = this;

      if (this.userInfo) {
        var params = {
          symbol_id: row.symbol_id,
          option: type,
          swap_type: 2
        };
        (0, _markets.apiAddOption)(params).then(function (res) {
          if (res.status == 200) {
            _this.$emit("onAddOption");

            _this.getOptionList();

            _this.$message({
              message: params.option == 1 ? _this.translateTitle("\u6DFB\u52A0\u81EA\u9009\u6210\u529F") : _this.translateTitle("\u5220\u9664\u81EA\u9009\u6210\u529F"),
              type: params.option == 1 ? "success" : "success"
            });
          }
        });
      } else {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      }
    },
    onSymbolChange: function onSymbolChange(item, column) {
      if (column != undefined && column.label == "币种") {
        return;
      }

      var trade_pair = item.info.name.toLowerCase(); // let swap_symbol_id = item.swap_symbol_id;

      this.symbol = trade_pair; // this.$router.push(`/exchange/${trade_pair}/${this.language}`);

      this.$router.push(this.routeSplicing(this.language, "exchange/".concat(trade_pair)));
      this.$emit("on-symbol-change", item);
      var params = {
        row: item
      };
      this.tableRowClassName(params);
    },
    onAreaChange: function onAreaChange(item) {
      this.currIndex = item.value;
    },
    getOptionList: function getOptionList() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$Account$getUse, userInfo;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Account.getUserInfo();

              case 2:
                _yield$Account$getUse = _context.sent;
                userInfo = _yield$Account$getUse.userInfo;

                if (userInfo) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                (0, _markets.apiGetOptionList)().then(function (res) {
                  if (res.status == 200) {
                    if (JSON.stringify(res.data) != "{}" && res.data.digital) {
                      _this2.selfOptionsList = res.data.digital;
                    }
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    compareOrderBy: function compareOrderBy(property) {
      return function (a, b) {
        if (a && b && a["info"] && b["info"] && a["info"][property] && b["info"][property]) {
          var value1 = a["info"][property];
          var value2 = b["info"][property];

          if (value1 - value2 != 0) {
            return value1 - value2;
          } else {
            var temp1 = a["from_symbol"];
            var temp2 = b["from_symbol"];

            if (temp1 < temp2) {
              // 按某种排序标准进行比较, a 小于 b
              return -1;
            }

            if (temp1 > temp2) {
              return 1;
            }

            return 0;
          }
        } else {
          return 0;
        }
      };
    }
  },
  watch: {},
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language"
  })), {}, {
    tableLoading: function tableLoading() {
      var val = 1;

      if (this.marketList.length > 0) {
        val = 0;
      } else {
        val = 1;
      }

      return val;
    },
    showList: function showList() {
      var _this3 = this;

      var tempArr = [];
      tempArr = this.marketList.filter(function (ele) {
        if (_this3.currIndex == "self") {
          if (_this3.selectSymbol != "") {
            if (ele.from_symbol.toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol).concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol, "/").concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 && _this3.selfOptionsList.indexOf(ele.symbol_id.toString() > -1)) {
              return true;
            }
          } else {
            return _this3.selfOptionsList.indexOf(ele.symbol_id.toString()) > -1;
          }
        } else if (_this3.currIndex == "usdt") {
          if (_this3.selectSymbol != "") {
            if (ele.from_symbol.toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol).concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol, "/").concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1) {
              return true;
            }
          } else {
            if (ele.info) {
              return ele.info.coin_to == "10007";
            }
          }
        } else if (_this3.currIndex == "busd") {
          if (_this3.selectSymbol != "") {
            if (ele.from_symbol.toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol).concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol, "/").concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1) {
              return true;
            }
          } else {
            if (ele.info) {
              return ele.info.coin_to == "10123";
            }
          }
        } else {
          if (_this3.selectSymbol != "") {
            if (ele.from_symbol.toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol).concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1 || "".concat(ele.from_symbol, "/").concat(ele.to_symbol).toLowerCase().indexOf(_this3.selectSymbol.trim().toLowerCase()) != -1) {
              return true;
            }
          } else {
            if (ele.info) {
              return ele.info.coin_to == "10005";
            }
          }
        }
      });
      tempArr.sort(this.compareOrderBy("order_by"));
      return tempArr;
    },
    tabList: function tabList() {
      var tempList = [{
        value: "self",
        label: this.translateTitle("自选")
      }, {
        value: "usdt",
        label: "USDT"
      }, {
        value: "btc",
        label: "BTC"
      }];
      var tempArr = [];
      this.marketList.forEach(function (ele) {
        tempArr.push(ele.to_symbol);
      });

      if (tempArr.indexOf("BUSD") >= 0) {
        tempList = [{
          value: "self",
          label: this.translateTitle("自选")
        }, {
          value: "usdt",
          label: "USDT"
        }, {
          value: "busd",
          label: "BUSD"
        }, {
          value: "btc",
          label: "BTC"
        }];
      } else {
        tempList = [{
          value: "self",
          label: this.translateTitle("自选")
        }, {
          value: "usdt",
          label: "USDT"
        }, {
          value: "btc",
          label: "BTC"
        }];
      }

      return tempList;
    }
  })
};
exports.default = _default2;